import React from 'react';
import { connect } from 'react-redux';
import { logOutToken } from '../actions/app_token'
import { updatePlan, loadPlan, clearPlan, loadPlanFailure, updatePlanFailure, getComparisons, getPlans, getPlansFailure, getTree } from '../actions/plan'
import { createRisk, createRiskFailure, clearRisk } from '../actions/risk'
import { Sidebar, Segment, Button, Menu, Icon } from 'semantic-ui-react';
import InfiniteScroll from 'react-infinite-scroll-component'
import { Link } from 'react-router-dom'
import history from '../history'
import * as paths from '../constants'
import Toastr from '../components/toastr';
import AdminTable from '../components/admin_table'
import AdminRiskCards from '../components/admin_cards'
import ComparisonTable from '../components/comparison_table'
import CustomDropdown from '../components/custom_dropdown'
import ComparisonSelection from '../components/comparison_selection'
import SystemHeader from '../components/system_header'
import { getTranslations } from '../actions/language'
import Feedback from '../components/feedback'
import AppComponent from '../components/app_component'
import { formatRiskColumns } from '../helpers/risk_helpers'
import ObjectITButton from '../components/developed_by_objectit';

import { getText } from '../helpers';

class AdminView extends AppComponent {
  constructor(props){
    super(props);
    this.page = 1;
    this.columnName = '';
    this.exportingPlan = false;
    this.selectedRiskId = 0
    this.allWorkPhases = []
    this.comparisonsPage = 1
    this.shouldUpdateTree = false

    var state = {
      plan: {},
      plans: [],
      risks: [],
      templates: [],
      templateId: parseInt(this.props.match.params.template_id, 10),
      loading: false,
      sidebarShown: false,
      templatesModalShown: false,
      plansModalShown: false,
      pendingMessage: "",
      editing: false,
      notifications: "",
      activeView: 'cards',
      activeCards: [],
      comparisonShown : false,
      comparisonSelectionShown: false,
      comparisons: [],
      dropdownList: [],
      comparisonColumns: [
        {
          dataField: 'risk_description',
          text: this.props.language.translations.risk_description,
          formatter: this.cellFormatter,
          headerStyle: {
            textAlign: "center",
            fontSize: '15px',
            width: '500px'
          },
          headerTitle: true,
          title: true,
          editCellClasses: 'textarea-style',
          align: 'left'
        }
      ],
      comparisonExpandAll: true,
      comparisonCollapseAll: false,
      tree: [],
      risk_ids: [],
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
      languageName: this.props.language.name,
      messageShown: false,
      messageHeader: '',
      messageBody: '',
      messageType: '',
      messageClass: '',
      shouldShowLoadingMessage: false
    }
    this.state = {...this.state, ...state }

    this.translateLikelihoodConversionToView = this.props.LanguageService.translateLikelihoodConversionToView.bind(this)
    this.translateRiskRatingDict = this.props.LanguageService.translateRiskRatingDict.bind(this)
    this.riskRatingDict = this.translateRiskRatingDict()
    this.likelihoodConversionToView = this.translateLikelihoodConversionToView()
  }

  componentWillMount = () => {
    this.setPermission()
    if (!this.props.signedIn) {
      return history.push(paths.LOGIN_PATH)
    }
    else if (!this.props.isAdmin) {
      return history.push(paths.DASHBOARD_PATH + '/risk_plans')
    }
  }

  componentDidMount = () => {
    this.props.getTranslations('English');
    // get template details
    if (this.props.match.params.template_id) {
      for(let i in this.props.plans) {
        if(this.props.plans[i].id === parseInt(this.props.match.params.template_id)) {
          this.setState({
            plan: this.props.plans[i],
          })
          break
        }
      }
    }
    // get risk tree for template cards view
    this.getRiskTree()

    // get plans for comparison
    var options = {
      is_template: false,
      template_id: this.props.match.params.template_id,
      plan_ids: this.props.user.plan_ids
    }
    this.props.getPlans(options)
  }

  componentWillReceiveProps = (nextProps) => {
    var translations = nextProps.language.translations
    if (nextProps.language !== this.props.language){
      var columns = this.state.comparisonColumns
      columns[0].text = nextProps.language.translations.risk_description
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
        comparisonColumns: columns
      },()=>{
        this.likelihoodConversionToView = this.translateLikelihoodConversionToView()
        this.riskRatingDict = this.translateRiskRatingDict()
      })
    }

    if (this.shouldUpdateTree && !nextProps.getTreePending){
      this.setState({
        tree: nextProps.tree,
        loading: false,
      }, ()=>{
        this.shouldUpdateTree = false
        this.onRiskTreeLoaded(nextProps.tree)
      })
    }

    if (nextProps.loadSuccess) {
      var newRisks = this.state.risks.concat(this.formatRisks(nextProps.plan.risks))
      this.setState({
        plan: nextProps.plan,
        risks: newRisks,
        showCardsLoading: false,
        loading: false,
      })

      this.props.resetLoad()
    }

    if(nextProps.getPlansSuccess) {
      this.setComparisonDropdownList(nextProps.plans)
      this.props.resetGetPlans()
    }

    if (nextProps.updatePending){
      this.setState({
        notifications: "  (" + translations.updating + "...)",
      });
      this.showNotifications(false);
    }

    if (nextProps.updateSuccess){
      this.setState({
        notifications: "  (" + translations.saved + ".)",
      })
      this.showNotifications(true);
      if (nextProps.updateSuccess ) {
        this.props.resetUpdate();
      }
    }

    if (nextProps.createRiskPending){
      this.setState({
        notifications: " (" + translations.creating + "...)",
      });
      this.showNotifications(false);
    }

    if (nextProps.createRiskSuccess){
      this.showNotifications(true);
      if(this.state.activeView === "cards") {
        this.getRiskTree()
      }
      else {
        this.setState({
          risks: this.updateRisks(this.state.risks, this.formatRisk(nextProps.risk))
        })
      }

      this.props.resetCreate()
    }

    if (nextProps.getComparisonsSuccess) {
      var comparisons = this.state.comparisons.concat(nextProps.comparisons)
      this.setState({
        comparisons: comparisons,
        loading: false
      })
    }

    if(nextProps.updateByLevelPending && nextProps.updateByLevelPending !== this.props.updateByLevelPending) {
      this.setState({
        notifications: "  (" + translations.updating + "...)",
      });
      this.showNotifications(false);
    }
    if(nextProps.updateByLevelSuccess) {
      this.showNotifications(true);
      this.setState({
        risks: this.updatedRisks(this.state.risks, nextProps.updateByLevelRisks),
      })

      this.props.clearRisk()
    }

    const isPending = (nextProps.updatePending || nextProps.loadPending || nextProps.getComparisonsPending || (nextProps.updateByLevelPending && nextProps.updateByLevelPending !== this.props.updateByLevelPending));
    this.handlePendingProps(isPending);

    if (this.state.comparisonShown) this.loadingMessage(isPending);
  };

  getRiskTree = () => {
    this.shouldUpdateTree = true
    this.setState({
      loading: true,
    }, () => this.props.getTree(this.state.templateId, "scope"))
  }

  onRiskTreeLoaded = (riskTree) => {
    for(var index in riskTree) {
      this.allWorkPhases = this.allWorkPhases.concat(riskTree[index].work_phase_or_ambient_exposure)
    }
  }

  cellFormatter = (cell, row, rowIndex) => {
    return (
     <span className='cell-style' cell={ cell } row={ rowIndex }>
      { cell.replace('\n', '') }
     </span>
    )
  }

  showNotifications = (timed) => {
    var notifs = document.getElementById("notifications");
    notifs.style.display = "inline";
    if (timed){
      setTimeout(()=>{ notifs.style.display = "none"; }, 3000);
    }
  }

  loadingMessage = (pending) => {
    if(this.state.comparisonSelectionShown) {
      return
    }

    var messageblock = document.getElementById("loading-message");
    if (pending){
      this.setState({
        pendingMessage: this.state.translations.fetching_activities
      })
      messageblock.style.display = "block";
    }
    else {
      messageblock.style.display = "none";
    }
  };

  handlePendingProps = (pending) => {
    if(this.state.comparisonSelectionShown) {
      return
    }

    this.setState({
      pendingMessage: this.state.translations.fetching_activities,
      shouldShowLoadingMessage: pending
    })
  }

  formatRisks = (risks) => {
    var new_risks = [];
    for (var i in risks) {
      new_risks = new_risks.concat(this.formatRisk(risks[i]))
    }
    return new_risks
  }

  formatRisk = (risk) => {
    var new_risk = {}
    var metadata = JSON.parse(risk.metadata)
    new_risk["activityGroup"] = risk.name
    new_risk["id"] = risk.id
    new_risk["hidden"] = risk.hidden
    new_risk = formatRiskColumns(new_risk, metadata);
    if(this.allWorkPhases.indexOf(metadata["work_phase_or_ambient_exposure"]) < 0) {
      this.allWorkPhases = this.allWorkPhases.concat(metadata["work_phase_or_ambient_exposure"])
    }

    this.formatControls(new_risk, risk.controls);

    return new_risk
  }

  formatControls = (new_risk, controls) => {
    new_risk["existing_preventative"] = controls.filter((control) => control.control_type === "existing-preventative")
    new_risk["existing_recovery"] = controls.filter((control) => control.control_type === "existing-recovery")
  }

  updateRisks = (risks, new_risk) => {
    for (var i in risks) {
      if(risks[i].id === this.selectedRiskId) {
          risks.splice(parseInt(i, 10) + 1, 0, new_risk)
          break
        }
    }
    return risks
  }

  updatedRisks = (risks, updated_risks) => {
    for(var i in updated_risks) {
      for(var j in risks) {
        if(updated_risks[i].id === risks[j].id) {
          risks[j] = this.formatRisk(updated_risks[i])
          break
        }
      }
    }
    return risks
  }

  toggleSideBar = () => {
    this.setState({ sidebarShown: true })
  }

  hideSideBar = () => {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  editPlanName = () => {
    var edit_name = document.getElementById("editable-name");
    var static_name = document.getElementById("static-name");
    edit_name.style.display = "inline";
    static_name.style.display = "none";
  }

  updatePlanName = () => {
    this.setState({ editing: false })
    var static_name = document.getElementById("static-name");
    var edit_name = document.getElementById("editable-name");
    edit_name.style.display = "none";
    static_name.style.display = "inline";
    this.props.updatePlan(this.state.plan);
  }

  handleNameChange = (e) => {
    this.setState({ editing: true })
    var plan = {...this.state.plan}
    plan.name = e.target.value
    this.setState({ plan });
  }

  fetchMoreRisk = () => {
    this.page++
    var options = {
      plan_id: this.state.templateId,
      include_hidden_risks: true,
      page: this.page,
      search_term: null,
      sort_by: { field: "work_phase_or_ambient_exposure", order: "asc" },
      column_name: this.columnName,
      filter_by_tags: null,
      is_control_report: null,
      control_tags: null,
      language: this.state.languageName
    }
    this.props.loadPlan(options);
  };

  loadPlan = () => {
    this.page = 1
    this.setState({
      risks: []
    })
    var options = {
      plan_id: this.state.templateId,
      include_hidden_risks: true,
      page: this.page,
      search_term: null,
      sort_by: { field: "work_phase_or_ambient_exposure", order: "asc" },
      column_name: this.columnName,
      filter_by_tags: null,
      is_control_report: null,
      control_tags: null,
      language: this.state.languageName
    }
    this.props.loadPlan(options);
  }

  onCreateRisk = (risk ) => {
    this.selectedRiskId = risk.selected_risk_id
    this.props.createRisk(this.state.templateId, risk)
  }

  renderLoadingMessage = () => {
    return (
      <div id="loading-message">
        <i className="loading circle notched icon plan-loading"></i>
        <span>{this.state.pendingMessage}</span>
      </div>
    )
  }

  setAllActivities = (activities) => {
    this.allActivities = activities
  }

  onToggleView = (view) => {
    this.setState({
      risks: [],
      tree: [],
      activeView: view,
      loading: true,
      comparisonShown: false,
      comparisonSelectionShown: false,
      sidebarShown: false,
      risk_ids: [],
    })

    if(view === "cards") {
      this.getRiskTree()
    }
    else {
      this.page = 1;
      var options = {
        plan_id: this.state.templateId,
        include_hidden_risks: true,
        page: this.page,
        search_term: null,
        sort_by: { field: "work_phase_or_ambient_exposure", order: "asc" },
        column_name: this.columnName,
        filter_by_tags: null,
        is_control_report: null,
        control_tags: null,
        language: this.state.languageName
      }
      this.props.loadPlan(options)
    }
  }

  onToggleActivity = (activity) => {
    var activeCards = this.state.activeCards

    if(activeCards.filter(card => card === activity).length > 0) {
      activeCards = activeCards.filter(card => card !== activity)
    }
    else {
      activeCards = activeCards.concat(activity)
    }

    this.setState({
      activeCards: activeCards,
    })
  }

  toggleActivities = (expand) => {
    var activeCards = []

    if(expand) {
      activeCards = Object.assign([], this.allWorkPhases)
    }

    this.setState({
      activeCards: activeCards,
    })
  }

  toggleComparisonSelection = () => {
    if (this.state.comparisonSelectionShown) {
      //Already shown
      return
    }
    this.setState({
      comparisonSelectionShown: !this.state.comparisonSelectionShown,
      sidebarShown: false,
      loading: true,
      activeView: 'comparison-selection',
      prevView: this.state.activeView
    }, () => {
      if (this.state.comparisonSelectionShown){
        this.shouldUpdateTree = true
        this.props.getTree(this.state.templateId)
      }
      this.toggleActivities(false)
    })
  }

  switchComparisonView = () => {
    this.setState({
      comparisonShown: !this.state.comparisonShown,
      comparisonSelectionShown: !this.state.comparisonSelectionShown,
      sidebarShown: false,
    }, () => {
      if (this.state.comparisonShown){
        this.fetchComparisons();
      }
    })
  }

  switchOffComparisonView = () => {
    this.setState({
      comparisonShown: false,
      comparisonSelectionShown: false,
      sidebarShown: false,
      activeView: this.state.prevView,
      tree: [],
      risk_ids: [],
    }, ()=>{
      this.onToggleView(this.state.activeView)
    })
    this.toggleActivities(false)
  }

  fetchMoreComparisons = () => {
    this.comparisonsPage++
    var options = {
      page:  this.comparisonsPage,
      risk_ids: this.state.risk_ids,
      plan_ids: this.state.plans,
      template_id: this.state.templateId
    }
    this.props.getComparisons(options);
  };

  fetchComparisons = () => {
    this.comparisonsPage = 1
    this.setState({
      comparisons: []
    })
    var options = {
      page:  this.comparisonsPage,
      risk_ids: this.state.risk_ids,
      plan_ids: this.state.plans,
      template_id: this.state.templateId
    }
    this.props.getComparisons(options);
  }

  getRiskRatingProps = (cell, isFinal) => {
    const { no_data } = this.state.translations;
    var risk_rating = isFinal ? cell.final_risk_rating : cell.current_risk_rating;
    var likelihood = isFinal ? cell.new_likelihood : cell.likelihood;
    var likelihood_rating = likelihood ? likelihood.value : null;
    if (likelihood_rating && risk_rating > 0 ) {
      return this.riskRatingDict[likelihood_rating.toString()][risk_rating]
    } else {
      return { class: '', label: no_data }
    }
  }

  planFormatter = (cell, row, rowIndex) => {
    if(cell === undefined) {
      return ""
    }
    const { existing_preventative_controls, existing_recovery_controls, tags, no_data, current_risk_rating,
            additional_preventative_controls, additional_recovery_controls, final_risk_rating } = this.state.translations

    var currentRatingProps = this.getRiskRatingProps(cell, false);
    var finalRatingProps = this.getRiskRatingProps(cell, true);

    return (
      <div className='plan-formatter-container' cell={ cell } row={ rowIndex }>
        <span className='cell-style plan-formatter'>
          { cell.existing_preventative &&
            <div>
              <label>{existing_preventative_controls}</label>
              { cell.existing_preventative.length > 0 &&
                <div>
                  <ul>
                    { cell.existing_preventative.map((control, index)=> {
                      var tagsList = control.tag_list ? control.tag_list.toString() : ''
                      return (
                        <li key={index}>
                          {control.name}
                          <br/>
                          {tags.toUpperCase()}: {tagsList}
                        </li>
                        )
                      })
                    }
                  </ul>
                </div>
              }
              { cell.existing_preventative.length === 0 &&
                <div>{no_data}</div>
              }

            </div>
          }
          { cell.existing_recovery &&
            <div>
              <label>{existing_recovery_controls}</label>
              { cell.existing_recovery.length > 0 &&
                <div>
                  <ul>
                    { cell.existing_recovery.map((control, index)=> {
                      return (
                        <li key={index}>{control.name}<br/>{tags.toUpperCase()}: {control.tag_list}</li>
                        )
                      })
                    }
                  </ul>
                </div>
              }
              { cell.existing_recovery.length === 0 &&
                <div>{no_data}</div>
              }

            </div>
          }
          <div>
            <label>{current_risk_rating}</label>
            {
              currentRatingProps &&
              <div className={ currentRatingProps.class.length > 0 ? currentRatingProps.class + ' comparison-rating' : '' }>{ currentRatingProps.label }</div>
            }
            {
              !currentRatingProps &&
              <div>{ no_data }</div>
            }
          </div>
        </span>
        <span className='cell-style plan-formatter'>
          { cell.additional_preventative &&
            <div>
              <label>{additional_preventative_controls}</label>
              { cell.additional_preventative.length > 0 &&
                <div>
                  <ul>
                    { cell.additional_preventative.map((control, index)=> {
                      return (
                        <li key={index}>{control.name}<br/>{tags.toUpperCase()}: {control.tag_list}</li>
                        )
                      })
                    }
                  </ul>
                </div>
              }
              { cell.additional_preventative.length === 0 &&
                <div>{no_data}</div>
              }

            </div>
          }
          { cell.additional_recovery &&
            <div>
              <label>{additional_recovery_controls}</label>
              { cell.additional_recovery.length > 0 &&
                <div>
                  <ul>
                    { cell.additional_recovery.map((control, index)=> {
                      return (
                        <li key={index}>{control.name}<br/>{tags.toUpperCase()}: {control.tag_list}</li>
                        )
                      })
                    }
                  </ul>
                </div>
              }
              { cell.additional_recovery.length === 0 &&
                <div>{no_data}</div>
              }

            </div>
          }
          <div>
            <label>{final_risk_rating}</label>
            {
              finalRatingProps &&
              <div className={ finalRatingProps.class.length > 0 ? finalRatingProps.class + ' comparison-rating' : '' }>{ finalRatingProps.label }</div>
            }
            {
              !finalRatingProps &&
              <div>{ no_data }</div>
            }
          </div>

        </span>
      </div>
    )
  }

  createComparisonColumns = () => {
    let comparisonColumns = [{
      dataField: 'risk_description',
      text: this.state.translations.risk_description,
      formatter: this.cellFormatter,
      headerStyle: {
        textAlign: "center",
        fontSize: '15px',
        width: '500px'
      },
      headerTitle: true,
      title: true,
      editCellClasses: 'textarea-style',
      align: 'left'
    }]

    let plans = this.state.plans
    let dropdownList = this.state.dropdownList
    if (plans.length > 0){
      for(let index in plans) {
        let text = ""
        for(let index2 in dropdownList) {
          if(plans[index] === dropdownList[index2].value) {
            text = dropdownList[index2].text
            break
          }
        }

        var column = {
          dataField: "plan_" + plans[index],
          text: text,
          formatter: this.planFormatter,
          headerStyle: {
            textAlign: "center",
            fontSize: '15px',
            width: '238px'
          },
          headerTitle: true,
          editCellClasses: 'textarea-style',
          align: 'left',
          hidden: false
        }
        comparisonColumns = comparisonColumns.concat(column)
      }
    }
    this.setState({
      comparisonColumns: comparisonColumns
    })
  }

  setComparisonDropdownList = (plans) => {
    let plans_ids = []
    let dropdownList = []

    for(let index in plans) {
      let new_obj = {
        text: plans[index].name,
        value: plans[index].id,
        status: true
      }
      dropdownList = dropdownList.concat(new_obj)
      plans_ids = plans_ids.concat(plans[index].id)
    }

    this.setState({
      plans: plans_ids,
      dropdownList: dropdownList
    }, () => this.createComparisonColumns())
  }

  updateComparisonDropdownList = (list) => {
    let plans = []
    let dropdownList = this.state.dropdownList
    for(let index in list) {
      for(let index2 in dropdownList) {
        if(list[index].value === dropdownList[index2].value) {
          dropdownList[index2].status = list[index].status
          break
        }
      }
      if(list[index].value != "" && list[index].status) {
        plans = plans.concat(list[index].value)
      }
    }

    this.setState({
      plans: plans,
      dropdownList: dropdownList
    }, () => {
      this.createComparisonColumns()
    })
  }

  setComparisonExpandAll = (value) => {
    this.setState({
      comparisonExpandAll: value
    })
  }

  setComparisonCollapseAll = (value) => {
    this.setState({
      comparisonCollapseAll: value
    })
  }

  toggleComparisonCards = (value) => {
    var tree = this.state.tree
    tree.map((item, index)=>{
      item.expanded = value
    })

    this.setState({
      tree: tree
    })

    if (value){
      this.setComparisonCollapseAll(true)
      this.setComparisonExpandAll(false)
    }
    else {
      this.setComparisonCollapseAll(false)
      this.setComparisonExpandAll(true)
    }

  }

  setRiskIds = (ids) => {
    this.setState({
      risk_ids: ids
    })
  }

  refreshRowsWithCreatedControls = (createdControls) => {
    let { risks } = this.state;

    for (const createdControl of createdControls) {
      const riskMatch = risks.find(risk => risk.id === createdControl.risk_id );

      if (!riskMatch) continue;

      if (createdControl.control_type === "existing-preventative") {
        riskMatch.existing_preventative.push(createdControl);
      } else if (createdControl.control_type === "existing-recovery") {
        riskMatch.existing_recovery.push(createdControl);
      }

    }

    this.setState({ risks }, this.showAddToPlansBackgroundJobInfo);
  }

  dismissMessage = () => {
    this.setState({
      messageShown: false,
      messageHeader: '',
      messageBody: '',
      messageType: '',
      messageClass: ''
    })
  }

  showMessage = (messageState, timeout=6000) => {
    if (!timeout) return this.setState(messageState);

    clearTimeout(this.messageTimer);
    this.messageTimer = setTimeout(() => {
      this.dismissMessage();
    }, timeout);

    this.setState(messageState);
  }

  showAddToPlansBackgroundJobInfo = () => {
    this.showMessage({
      messageBody: getText("Please be Aware - this system will automatically add these new template controls to all plans created with this template."),
      messageShown: true,
      messageType: "info",
      messageClass: "background-job-info",
      messageHeader: getText("Info")
    }, null);
  };

  showRemoveFromPlansBackgroundJobInfo = () => {
    this.showMessage({
      messageBody: getText("Please be Aware - this system will automatically remove these template controls from all plans created with this template."),
      messageShown: true,
      messageType: "info",
      messageClass: "background-job-info",
      messageHeader: getText("Info")
    }, null);
  };

  render() {
    const { sidebarShown, plan, activeView, messageShown, messageBody, messageType, messageClass, messageHeader, shouldShowLoadingMessage, pendingMessage } = this.state
    const { edit_files, open_risk_comparison, edit_in_table, edit_in_cards, switch_to_table, switch_to_cards,
            expand_activities, collapse_activities, risk_comparison_filters, open_comparisons, risk_comparison,
            goto_filters, end_of_records, manage_users } = this.state.translations

    const shouldShowScrollInstruction = !this.props.loadPending && this.state.risks.length > 0;

    return (
      <div className="App">
        <Sidebar.Pushable as={Segment} id='template-segment'>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            <Menu.Item name='home' as={Link} to={paths.DASHBOARD_PATH + '/risk_templates'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div>{edit_files}</div></span>
            </Menu.Item>
            <Menu.Item className={(activeView === 'cards' && !this.state.comparisonShown && !this.state.comparisonSelectionShown) ? "selected" :  ""} name='switch_to_cards' onClick={ () => this.onToggleView("cards") }>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div>{switch_to_cards}</div></span>
            </Menu.Item>
            <Menu.Item className={(activeView === 'table' && !this.state.comparisonShown && !this.state.comparisonSelectionShown) ? "selected" :  ""} name='switch_to_table' onClick={ () => this.onToggleView("table") }>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div>{switch_to_table}</div></span>
            </Menu.Item>
            <Menu.Item className={(this.state.comparisonShown || this.state.comparisonSelectionShown) ? "selected" :  ""} name='open_comparison' onClick={()=>this.toggleComparisonSelection()}>
              <span className="sidebar-button-wrap"><Icon name=''></Icon><div>{open_risk_comparison}</div></span>
            </Menu.Item>
            <Menu.Item name='users' as={Link} to={paths.USERS_PATH}>
              <span className="sidebar-button-wrap"><Icon name='users'></Icon><div>{manage_users}</div></span>
            </Menu.Item>
            <Menu.Item name='send_feedback' onClick={()=>{}}>
              <span className="sidebar-button-wrap"><Feedback translations={this.state.translations}/></span>
            </Menu.Item>
            <Menu.Item>
              <ObjectITButton />
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>

              <SystemHeader
                toggleSideBar={this.toggleSideBar}
                editPlanName={this.editPlanName}
                updatePlanName={this.updatePlanName}
                handleNameChange={this.handleNameChange}
                notifications={this.state.notifications}
                planName={plan.name}
                showLogout={true}
                view='admin-template'
                showMenuButton={true}
                showLoading={this.state.loading || this.state.showCardsLoading}
                permission={this.state.permission}
              />
              { !this.state.comparisonShown && !this.state.comparisonSelectionShown &&
                <Menu>
                  <div className="admin-view-title ui header">{ (activeView === "table") ? edit_in_table: edit_in_cards }</div>
                  <div className="admin-view-button">
                    <Button color="blue" onClick={ () => this.onToggleView((activeView === "table") ? "cards" : "table") }>
                      { (activeView === "table") ? switch_to_cards: switch_to_table }
                    </Button>
                  </div>
                  { (activeView === 'cards') && <div className="admin-view-expand">
                    {
                      (this.state.activeCards.length < this.allWorkPhases.length) &&
                      <a color="blue" onClick={ () => this.toggleActivities(true) }>{expand_activities}</a>
                    }
                    {
                      (this.state.activeCards.length > 0) &&
                      <a color="blue" onClick={ () => this.toggleActivities(false) }>{collapse_activities}</a>
                    }
                  </div>}
                </Menu>
              }
              { this.state.comparisonSelectionShown &&
                <Menu>
                  <div className="admin-view-title ui header">{risk_comparison_filters}</div>
                  <div className="admin-view-button">
                    <Button color="blue" onClick={ () => this.switchComparisonView() }>
                      {open_comparisons}
                    </Button>
                  </div>
                  <CustomDropdown
                    className="custom-dropdown"
                    list={this.state.dropdownList}
                    callback={this.updateComparisonDropdownList.bind(this)}
                    translations={this.state.translations}
                  />
                  <div className="comparison-selection-expand">
                    {
                      (this.state.comparisonExpandAll) &&
                      <a color="blue" onClick={ () => this.toggleComparisonCards(true) }>{expand_activities}</a>
                    }
                    {
                      (this.state.comparisonCollapseAll) &&
                      <a color="blue" onClick={ () => this.toggleComparisonCards(false) }>{collapse_activities}</a>
                    }
                  </div>
                </Menu>
              }
              { this.state.comparisonShown &&
                <Menu>
                  <div className="admin-view-title ui header">{risk_comparison}</div>
                  <div className="admin-view-button">
                    <Button color="blue" onClick={ () => this.switchComparisonView() }>
                      {goto_filters}
                    </Button>
                  </div>
                </Menu>
              }
              { (!this.state.comparisonShown && !this.state.comparisonSelectionShown) &&
                <div className={ "admin-view " + (activeView === 'table') }>
                  {
                    messageShown &&
                    <Toastr className={messageClass} messageHeader={messageHeader} messageBody={messageBody} messageType={messageType} dismiss={ this.dismissMessage }/> 
                  }
                  <InfiniteScroll
                    dataLength={this.state.risks.length}
                    next={this.fetchMoreRisk}
                    hasMore={true}
                    height={1}
                    endMessage={
                      <p style={{ textAlign: 'center' }}>
                        <b>{end_of_records}</b>
                      </p>
                    }
                  >
                    <AdminTable
                      risks={ this.state.risks }
                      planId={this.state.templateId}
                      loadPlan={ this.loadPlan.bind(this) }
                      createRisk={ this.onCreateRisk }
                      refreshRowsWithCreatedControls={this.refreshRowsWithCreatedControls}
                      showRemoveFromPlansBackgroundJobInfo={this.showRemoveFromPlansBackgroundJobInfo}
                      shouldShowScrollInstruction={shouldShowScrollInstruction}
                      shouldShowLoadingMessage={shouldShowLoadingMessage}
                      loadingMessage={pendingMessage}
                    />
                  </InfiniteScroll>
                </div>
              }
              { (!this.state.comparisonShown && !this.state.comparisonSelectionShown) &&
                <div className={ "admin-cards admin-view " + (activeView === 'cards') }>
                  <AdminRiskCards
                    risks={ this.state.risks }
                    planId={this.state.templateId}
                    activeCards={ this.state.activeCards }
                    createRisk={ this.onCreateRisk }
                    onToggleActivity={ (activity) => this.onToggleActivity(activity) }
                    setAllActivities={this.setAllActivities.bind(this)}
                    translations={this.state.translations}
                    risksTree={this.state.tree}
                    languageName={this.state.languageName}
                    permission={this.state.permission}
                    instanceConfig={this.props.instanceConfig}
                  />
                </div>
              }
              {
                this.state.comparisonShown &&
                <div>
                  <InfiniteScroll
                    dataLength={this.state.comparisons.length}
                    next={this.fetchMoreComparisons}
                    hasMore={true}
                    loader={this.renderLoadingMessage()}
                    height={1}
                    endMessage={
                      <p style={{ textAlign: 'center' }}>
                        <b>{end_of_records}</b>
                      </p>
                    }
                  >
                    <ComparisonTable
                      ref='comparison_table'
                      columns={ this.state.comparisonColumns }
                      comparisons={ this.state.comparisons }
                      translations={this.state.translations}
                    />
                  </InfiniteScroll>
                </div>
              }
              {
                this.state.comparisonSelectionShown &&
                <div className="admin-cards admin-view comparison-selection-view">
                  <ComparisonSelection
                    riskIds={this.state.risk_ids}
                    tree={this.state.tree}
                    setComparisonCollapseAll={this.setComparisonCollapseAll.bind(this)}
                    setRiskIds={this.setRiskIds.bind(this)}
                    translations={this.state.translations}
                  />
                </div>
              }
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    isAdmin: state.app_token.isAdmin,
    user: state.app_token.user,
    plan: state.plan.plan,
    plans: state.plan.plans,
    pendingMessage: state.plan.pendingMessage,
    loadSuccess: state.plan.loadSuccess,
    loadPending: state.plan.loadPending,
    updateSuccess: state.plan.updateSuccess,
    updatePending: state.plan.updatePending,
    getPlansSuccess: state.plan.getPlansSuccess,
    isTemplate: state.plan.isTemplate,
    createRiskSuccess: state.risk.updateSuccess,
    createRiskPending: state.risk.pending,
    updateByLevelPending: state.risk.updateByLevelPending,
    updateByLevelSuccess: state.risk.updateByLevelSuccess,
    updateByLevelRisks: state.risk.updateByLevelRisks,
    risk: state.risk.risk,
    comparisons: state.plan.comparisons,
    getComparisonsSuccess: state.plan.getComparisonsSuccess,
    getComparisonsPending: state.plan.getComparisonsPending,
    tree: state.plan.tree,
    getTreePending: state.plan.getTreePending,
    language: state.language.language,
    languages: state.language.languages,
    instanceConfig: state.instance.instanceConfig
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    updatePlan: (plan) => {
      dispatch(updatePlan(plan))
    },
    loadPlan: (options) => {
      dispatch(loadPlan(options))
    },
    resetLoad: () => {
      dispatch(loadPlanFailure());
    },
    resetUpdate: () => {
      dispatch(updatePlanFailure());
    },
    getPlans: (options) => {
      dispatch(getPlans(options));
    },
    resetGetPlans: () => {
      dispatch(getPlansFailure());
    },
    createRisk: (planId, risk) => {
      dispatch(createRisk(planId, risk))
    },
    resetCreate: () => {
      dispatch(createRiskFailure())
    },
    clearStates: () => {
      dispatch(clearPlan());
    },
    getComparisons: (options) => {
      dispatch(getComparisons(options));
    },
    clearRisk: () => {
      dispatch(clearRisk())
    },
    getTree: (planId, view_type) => {
      dispatch(getTree(planId, view_type))
    },
    getTranslations: (name) => {
      dispatch(getTranslations(name))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminView);



// WEBPACK FOOTER //
// ./src/views/admin_template.js